const x0 = 0;
const x1 = 0.25;
const x2 = 0.5;
const x3 = 0.75;
const x4 = 1;
const y0 = 0;
const y1 = 0.2789115646258504;
const y2 = 0.5;
const y3 = 0.7210884353741496;
const y4 = 1;

const fieldAreas = [
  // x1, y1, x2, y2
  [x0, y0, x1, y1],
  [x1, y0, x2, y1],
  [x2, y0, x3, y1],
  [x3, y0, x4, y1],
  [x0, y1, x1, y2],
  [x1, y1, x2, y2],
  [x2, y1, x3, y2],
  [x3, y1, x4, y2],
  [x0, y2, x1, y3],
  [x1, y2, x2, y3],
  [x2, y2, x3, y3],
  [x3, y2, x4, y3],
  [x0, y3, x1, y4],
  [x1, y3, x2, y4],
  [x2, y3, x3, y4],
  [x3, y3, x4, y4],
];

const emptyData = [
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
];

function getEmptyField() {
  const emptyField = [];
  for (let i = 0; i < 16; i++) {
    emptyField.push(0);
  }
  return emptyField;
}

/**
 * @author Alejandro
 * @description Determines at witch area of the field the given point belongs
 * @param {number} x
 * @param {number} y
 * @return {number} - The field's area index, can be any between 0 and 15
 */
export function findFieldArea(x, y) {
  // If 'y' is bigger than 0.5 search in half field only
  let fieldAreaIndex = 0;
  for (let i = y > y2 ? 8 : 0; i < fieldAreas.length; i++) {
    if (x >= fieldAreas[i][0] && x <= fieldAreas[i][2] && y >= fieldAreas[i][1] && y <= fieldAreas[i][3]) {
      fieldAreaIndex = i;
      break;
    }
  }
  return fieldAreaIndex;
}

/**
 * @author Alejandro
 * @description Converts a field array with length of 16 items, to a matrix of 4 x 4 items
 * @param {Array} fieldArray
 * @return {Array}
 */
function createFieldMatrixFromArray(fieldArray) {
  const fieldMatrix = [];
  while (fieldArray.length) {
    fieldMatrix.push(fieldArray.splice(0, 4));
  }
  return fieldMatrix;
}

/**
 * @author Alejandro
 * @description Get an object with all fields sections filled.
 * @param {Array} playList - All plays to be filtered
 * @param {Array<number>} timeSelected
 * @param {Object} valuesToFilter - Contains categoriesId to filter
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @param {number=} teamId
 * @return {Array<Object>}
 */
export function getStatisticsFields(playList, timeSelected, valuesToFilter, playValuesIndex, teamId) {
  if (!playList || playList.length === 0) {
    return getEmptyData(Object.values(valuesToFilter));
  }
  const fieldsToShow = {};
  for (const [k, v] of Object.entries(valuesToFilter)) {
    fieldsToShow[k] = {
      name: v.name,
      fieldCount: getEmptyField(),
      position: v.position,
      isNegative: v.isNegative,
      categoryIds: v.categoryIds,
      coordinatePoint: valuesToFilter[k].coordinatePoint,
      generalName: v.generalName,
      singleName: v.singleName,
    };
  }
  for (const play of playList) {
    if (
      teamId
        ? teamId === play[playValuesIndex.teamId] && timeSelected.includes(play[playValuesIndex.section])
        : timeSelected.includes(play[playValuesIndex.section])
    ) {
      for (const key of Object.keys(valuesToFilter)) {
        if (valuesToFilter[key].categoryIds.includes(play[playValuesIndex.categoryId])) {
          fieldsToShow[key].fieldCount[
            findFieldArea(
              play[playValuesIndex[`coordinate${valuesToFilter[key].coordinatePoint}X`]],
              play[playValuesIndex[`coordinate${valuesToFilter[key].coordinatePoint}Y`]],
            )
          ]++;
        }
      }
    }
  }
  return Object.values(fieldsToShow).reduce(
    (accumulator, { name, fieldCount, isNegative, categoryIds, coordinatePoint, generalName, singleName }) => {
      accumulator.push({
        name,
        data: createFieldMatrixFromArray(fieldCount),
        isNegative,
        categoryIds,
        coordinatePoint,
        generalName,
        singleName,
      });
      return accumulator;
    },
    [],
  );
}

/**
 * @author Alejandro Martinez
 * @param {Array<{
 *   categoryIds: Array<number>,
 *   coordinatePoint: number
 *   isNegative: boolean,
 *   name: string,
 *   position: number
 * }>} valuesToFilter
 * @return {Array<{
 *   name: string,
 *   data: Array<Array<number>>
 * }>}
 */
function getEmptyData(valuesToFilter) {
  return valuesToFilter.map(value => {
    return {
      name: value.name,
      data: emptyData,
      isNegative: false,
    };
  });
}
